import styled from 'styled-components';
const FlightDelayListWrapper = styled.div`
    min-width: 400px;
    padding-top: 1.5rem;
    .field-radiobutton{
        
    border: 1px solid #6B47F5;border-radius: 5px;margin:10px 0;padding: 10px;
        label {margin-left: 10px;width: 90%; cursor: pointer;}
        .p-radiobutton .p-radiobutton-box {
            border-color: #818B9B;
            background: #818B9B;
        }
        .p-radiobutton .p-radiobutton-box::before{
            content: "✔";
            color:#fff;
            transform: rotate(25deg);
            font-size: 12px;
            font-weight: 700;
        }
        .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {width: 0px;height: 0px;}
        .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
            border-color: #6B47F5;
            background: #6B47F5;
            color: #ffffff;
        }
        .delay-time {
            font-weight: 700;
            font-size: 21px;
            line-height: 25px;
            text-transform: capitalize;
            color: #818B9B;
        }
        .delay-amount {
            font-weight: 800;
            font-size: 21px;
            line-height: 100%;
            text-transform: capitalize;
            color: #6B47F5;
            text-align: right;
            float: right;
        }
    }
    .box{
        border: 1px solid #6B47F5;
        *{
            color: #6B47F5 !important;
        }
    }
    .p-radiobutton .p-radiobutton-box.p-highlight{
        border-color: #6B47F5;
        background: #6B47F5;
    }
    .p-button.p-component.p-button-warning {
        width: 100%;
        background: #6B47F5;
        border-radius: 5px;
        margin-top: 20px;
        text-transform:uppercase;
    }
    button.p-button.p-component.p-button-outlined.p-button-info{
        width: 100%;
        margin-top: 20px;
        text-transform:uppercase;
    }
`;
export default FlightDelayListWrapper;